module.exports = __webpack_public_path__ + "img/download.53b41fd6.svg";